<template>
  <div class="plans">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Plans</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewPlan"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new plan
          </v-btn>
        </div>
        <v-card class="pa-2 adressesList" outlined tile>
          <v-data-table
            v-model="selectedPlan"
            :headers="headers"
            :items="planList"
            :items-per-page="-1"
            :sort-by="['Name']"
            item-key="Id"
            single-select
            dense
            @click:row="selectPlan"
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedPlanExists" outlined dense type="info">
          Please select plan or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form ref="planForm" v-model="isFormValid" lazy-validation class="planForm">
            <v-btn class="mb-4" @click="showPlanDocs">Plan Documents</v-btn>
            <v-divider class="mb-4"></v-divider>
            <FormPanel :formElements="tabElements" :readOnly="!isEditMode"></FormPanel>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedPlanExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox" v-model="dialog"></Dialog>
    <v-dialog v-model="docsDialog" @keydown.esc="cancel" width="900">
      <v-card class="memberDocuments">
        <v-data-table
          :headers="docsHeaders"
          :items="documentList"
          :items-per-page="-1"
          :item-class="itemRowBackground"
          @click:row="rowClick"
        >
          <template v-slot:[`item.Actions`]="{ item }">
            <div class="actionBtnContainer">
              <v-icon small class="mr-3 action-icon" @click="viewDocument(item)"> mdi-eye </v-icon>
              <v-icon small class="mr-3 action-icon" @click="downloadDocument(item)"> mdi-download </v-icon>
              <v-icon small class="mr-2 action-icon" @click="onDeleteDocument(item)"> mdi-delete </v-icon>
            </div>
          </template>
        </v-data-table>
        <div class="docsBtnContainer">
          <v-btn @click="addDocument" color="primary">Upload Document</v-btn>
        </div>
      </v-card>
      <v-dialog v-model="uploadDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Upload Document </v-card-title>

          <v-card-text>
            <v-select label="Document Type" :items="typesList" v-model="documentType"></v-select>
            <v-text-field label="Description" v-model="description"></v-text-field>
            <v-file-input
              v-model="uploadFile"
              ref="file"
              label="Member Document"
              accept=".jpg, .pdf, .bmp, .docx, .png"
              dense
            ></v-file-input>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="uploadDocument"> Ok </v-btn>
            <v-btn color="secondary" text @click="uploadDialog = false"> Cancel </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Dialog ref="confirmationDialog" />
    </v-dialog>
  </div>
</template>
<script>
import Dialog from '@/components/layout/Dialog.vue';
import FormPanel from '@/components/FormPanel.vue';
import Utils from '@/utils.js';

export default {
  name: 'Plans',
  components: {
    FormPanel,
    Dialog,
  },
  data() {
    return {
      tabElements: [],
      isEditMode: false,
      isFormValid: false,
      dialog: false,
      planList: [],
      planId: 0,
      currentPlan: null,
      headers: [{ text: 'Name', value: 'ShortName', sortable: true }],
      selectedPlan: [],

      docsDialog: false,
      selectedLink: null,
      selectedRow: null,
      uploadFile: null,
      documentType: '',
      description: '',
      uploadDialog: false,
      typesList: [
        'Accounts',
        'Audits',
        'Birth Certificate',
        'Driving Licence',
        'Miscellaneous',
        'Marriage Certificate',
        'Newsletters',
        'Passport',
        'Photo',
        'Rules and Booklets',
        'Signature',
        'Statement',
        'Trustee Meetings',
        'Valuations',
        'Other',
      ],
      documentList: [],
      docsHeaders: [
        { text: 'Document Type', value: 'Reference' },
        { text: 'Document Name', value: 'ShortName' },
        { text: 'Description', value: 'Description' },
        { text: 'Upload Date', value: 'Date' },
        { text: '', value: 'Actions', sortable: false },
      ],
    };
  },
  mounted: function () {
    this.getPlanForm();
    this.getPlanList();
  },
  computed: {
    planListLength() {
      return this.planList.length;
    },
    isSelectedPlanExists() {
      return this.selectedPlan && this.selectedPlan.length > 0;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  watch: {},

  methods: {
    selectPlan(item, row) {
      row.select(true);
      this.getPlan(item.Id);
    },
    onAddNewPlan() {
      this.clearData();
      this.selectedPlan = [];
      this.isEditMode = true;
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedPlanExists) this.getPlan(this.selectedPlan[0].Id);
      else this.clearData();
    },
    onDelete() {
      this.deletePlan();
    },
    saveChanges() {
      const isFormValid = this.$refs.planForm.validate();
      if (isFormValid) {
        if (this.isSelectedPlanExists) {
          this.updatePlan();
        } else {
          this.addNewPlan();
        }
      }
    },

    async getPlan(planId) {
      try {
        let response = await this.$api.get('/plans/getPlan', { params: { planId: planId } });
        if (!response.data) {
          const msg = 'Unable to load service with id ' + planId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        this.currentPlan = response.data;
        var data = response.data;
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },

    async getPlanList(planId) {
      try {
        let response = await this.$api.get('/plans/getPlanList');
        if (!response.data || !response.data.length) {
          const msg = 'Unable to load plans';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        var data = response.data;
        this.planList = data;

        if (this.planList && this.planList.length) {
          if (planId) {
            const selected = this.planList.find((x) => x.Id == planId);
            if (selected) this.selectedPlan = [selected];
            this.getPlan(planId);
          } else {
            var plan = this.planList[0];
            this.selectedPlan = [plan];
            this.getPlan(plan.Id);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async deletePlan() {
      await this.$refs.messageBox.open(
        'Confirmation',
        'Are you sure you wish to delete this record ?'
      );
      try {
        await this.$api.delete('/plans/deletePlan?id=' + this.currentPlan.PlanId);
        this.selectedPlan = [];
        this.clearData();
        this.getPlanList();
      } catch (err) {
        console.error(err);
      }
    },
    async addNewPlan() {
      try {
        const newPlan = {};
        this.formElements.forEach((el) => {
          newPlan[el.FieldName] = el.Value;
        });
        newPlan.PlanId = 0;
        const response = await this.$api.post('/plans/updatePlan', newPlan);
        const data = response.data;
        this.getPlanList(data.Value);
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async updatePlan() {
      try {
        Object.keys(this.currentPlan).forEach((e) => {
          var key = e;
          let item = this.formElements.find((o) => o.FieldName === key);
          if (item != null) {
            this.currentPlan[e] = item.Value;
          }
        });
        this.currentPlan.PlanStartedString = this.currentPlan.PlanStarted;
        await this.$api.post('/plans/updatePlan', this.currentPlan);
        this.isEditMode = false;
        this.getPlanList();
      } catch (err) {
        console.error(err);
      }
    },
    clearData() {
      this.formElements.forEach(function (e) {
        e.Value = '';
      });
    },
    async getPlanForm() {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=Plans&planId=0'
        );
        var elements = response.data.filter((f) => f.Visible == true);
        this.formElements = elements;
        this.tabElements = elements.filter(
          (f) => f.ParentId === 'FormFields' && f.ChildPanel === ''
        );
      } catch (err) {
        console.error(err);
      }
    },

    async getPlanDocumentsList() {
      try {
        let response = await this.$api.get(
          `/plans/GetPlanDocumentList?planId=${this.currentPlan.PlanId}`
        );
        if (response.data && response.data.length > 0) {
          this.documentList = response.data;
        } else {
          this.documentList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },

    itemRowBackground: function (item) {
      return item == this.selectedRow ? 'selected' : '';
    },

    showPlanDocs() {
      this.getPlanDocumentsList();
      this.docsDialog = true;
    },

    rowClick: function (item) {
      this.selectedRow = item;
    },
    addDocument: function () {
      this.uploadDialog = true;
    },

    async onDeleteDocument(item) {
      this.selectedRow = item;
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteDocument();
      } catch (err) {
        console.log();
      }
    },

    async deleteDocument() {
      try {
        await this.$api.delete('/Plans/deletePlanDocument?id=' + this.selectedRow.Id);

        this.getPlanDocumentsList();
      } catch (err) {
        console.error(err);
      }
    },

    async uploadDocument() {
      try {
        let data = new FormData();
        data.append('PlanId', this.currentPlan.PlanId);
        data.append('DocumentType', this.documentType);
        data.append('Description', this.description);
        data.append('File', this.uploadFile);
        await this.$api({
          url: '/Plans/UploadPlanDocument',
          method: 'POST',
          data: data,
        });

        this.uploadDialog = false;
        this.getPlanDocumentsList();
      } catch (error) {
        console.error(error);
        this.$store.commit('setNotificationMessage', { type: 'error', text: error.message });
      }
    },

    async viewDocument(item) {
      this.selectedRow = item;
      var id = this.selectedRow.Id;
      try {
        const response = await this.$api.get(
          '/Plans/ViewPlanDocument?planId=' + this.currentPlan.PlanId + '&documentId=' + id,
          {
            responseType: 'blob',
          }
        );

        if (response && response.data) {
          const mimeType = response.headers['content-type'] || 'application/octet-stream';
          const blob = new Blob([response.data], { type: mimeType });

          const url = URL.createObjectURL(blob);
          const newTab = window.open(url, '_blank');
          if (!newTab) {
            console.warn('Popup blocked. User may need to allow popups for this site.');
          }
          setTimeout(() => URL.revokeObjectURL(url), 10000);

          console.log('File downloaded successfully!');
        } else {
          console.error('No data in response.');
        }
      } catch (error) {
        console.error('Error making GET request:', error);
      }
    },

    async downloadDocument(item) {
      this.selectedRow = item;
      var id = this.selectedRow.Id;
      try {
        const response = await this.$api.get(
          '/Plans/viewPlanDocument?planId=' + this.currentPlan.PlanId + '&documentId=' + id,
          {
            responseType: 'blob',
          }
        );

        if (response && response.data) {
          const mimeType = response.headers['content-type'] || 'application/octet-stream';
          const blob = new Blob([response.data], { type: mimeType });
          const fileName = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
            : 'downloaded_file.pdf';

          const url = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
          URL.revokeObjectURL(url);

          console.log('File downloaded successfully!');
        } else {
          console.error('No data in response.');
        }
      } catch (error) {
        console.error('Error making GET request:', error);
      }
    },
  },
};
</script>

<style scoped>
.plans {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.plans .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.plans .formContainer .planForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 10px;
}

.actionBtnContainer {
  display: flex;
  justify-content: flex-end;
}

.actionBtnContainer .actionBtn {
  margin-top: 4px;
}

.action-icon:hover {
  color: #1976d2; 
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.memberDocuments {
  .selected td {
    background-color: #778899 !important;
  }

  .docsBtnContainer{
    padding: 15px;

    button {
      margin-right: 10px;
    }

    a {
      margin-right: 10px;
    }
  }

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
